import * as _ from 'lodash';
import { OBJECT_TYPES } from "../../../components/filter/src/scripts/cian.filter.object-type.service";

const floorExtended = [
  'floorn',
  'floor',
  'is_basement',
  'is_semibasement',
  'is_first_floor',
];

const filtersForIndustry = [
  ...floorExtended,
  'building_lift_types_type',
  'building_cranage_types_type',
  'building_gates_type',
  'building_heating_type',
  'ceiling_height',
];

const filtersForPSN = [
  ...floorExtended,
];

const commercial = {
  _common: [
    'office_type',
    'price_sm',
    'total_area',
    'currency',
    'bs_center',
    'foot_min',
    'only_foot',
    'contract'
  ],

  [OBJECT_TYPES.OFFICE]: [
    ...floorExtended,
    'has_furniture',
    'parking_type',
  ],

  [OBJECT_TYPES.SHOPPING_AREA]: [
    ...floorExtended,
    'placement_type',
    'has_furniture',
  ],

  [OBJECT_TYPES.INDUSTRY]: filtersForIndustry,
  [OBJECT_TYPES.WAREHOUSE]: filtersForIndustry,

  [OBJECT_TYPES.FREE_APPOINTMENT]: filtersForPSN,
  [OBJECT_TYPES.PUBLIC_CATERING]: filtersForPSN,
  [OBJECT_TYPES.CARCARE]: filtersForPSN,
  [OBJECT_TYPES.HOUSEHOLD_SERVICES]: filtersForPSN,

  [OBJECT_TYPES.BUILDING]: [
    'house_year',
    'floorn',
    'has_furniture',
    'parking_type',
  ],

  [OBJECT_TYPES.BUSINESS]: [
    'floor',
    'floorn',
    'estate_type',
    'has_equipment',
    'property_type',
    'has_furniture',
    'parking_type',
  ],

  [OBJECT_TYPES.GARAGE]: [
    'garage_type',
    'garage_garage_type',
    'garage_material',
    'garage_status',
    'has_light',
    'has_electricity',
    'has_water',
    'has_heating',
    'has_extinguishing_system',
    'parking_type',
  ],
};

const objectGroupsByParam = {
  'building_type2': [
    OBJECT_TYPES.OFFICE,
    OBJECT_TYPES.SHOPPING_AREA,
    OBJECT_TYPES.INDUSTRY,
    OBJECT_TYPES.WAREHOUSE,
    OBJECT_TYPES.FREE_APPOINTMENT,
    OBJECT_TYPES.PUBLIC_CATERING,
    OBJECT_TYPES.CARCARE,
    OBJECT_TYPES.HOUSEHOLD_SERVICES,
  ],
  'building_type__building': [
    OBJECT_TYPES.BUILDING,
  ],
  'specialty_types': [
    OBJECT_TYPES.FREE_APPOINTMENT,
    OBJECT_TYPES.PUBLIC_CATERING,
    OBJECT_TYPES.CARCARE,
    OBJECT_TYPES.HOUSEHOLD_SERVICES,
    OBJECT_TYPES.SHOPPING_AREA,
    OBJECT_TYPES.BUSINESS,
  ],

  'building_class_type': [
    OBJECT_TYPES.OFFICE,
    OBJECT_TYPES.SHOPPING_AREA,
    OBJECT_TYPES.BUILDING,
  ],
  'building_class_type__warehouse': [
    OBJECT_TYPES.WAREHOUSE,
    OBJECT_TYPES.INDUSTRY,
  ],

  'building_house_line_type': [
    OBJECT_TYPES.BUILDING,
  ],
  'building_house_line_type__shopping_area': [
    OBJECT_TYPES.SHOPPING_AREA,
  ],

  'condition_type': [
    OBJECT_TYPES.OFFICE,
  ],
  'condition_type__free_appointment_object': [
    OBJECT_TYPES.SHOPPING_AREA,
    OBJECT_TYPES.FREE_APPOINTMENT,
    OBJECT_TYPES.PUBLIC_CATERING,
    OBJECT_TYPES.CARCARE,
    OBJECT_TYPES.HOUSEHOLD_SERVICES,
    OBJECT_TYPES.BUILDING,
    OBJECT_TYPES.BUSINESS,
  ],
  'condition_type__industry': [
    OBJECT_TYPES.WAREHOUSE,
    OBJECT_TYPES.INDUSTRY,
  ],

  'enter': [
    OBJECT_TYPES.OFFICE,
  ],
  'input_type': [
    OBJECT_TYPES.SHOPPING_AREA,
    OBJECT_TYPES.FREE_APPOINTMENT,
    OBJECT_TYPES.PUBLIC_CATERING,
    OBJECT_TYPES.CARCARE,
    OBJECT_TYPES.HOUSEHOLD_SERVICES,
    OBJECT_TYPES.BUILDING,
  ],
};

_.forEach(objectGroupsByParam, (objects, filterParam) => {
  objects.forEach(objectName => {
    commercial[objectName] = (commercial[objectName] || []).concat(filterParam);
  })
});

export default commercial;
export { objectGroupsByParam };



// WEBPACK FOOTER //
// ./src/serp/services/available-filters/available-filters.commercial.js